import size from 'lodash/size';
import isArray from 'lodash/isArray';
import { format, parseISO } from 'date-fns';
import * as locale from 'date-fns/locale';
import { changeItemIndex } from '../helper';

export const Mapper = (data, tableType) => {
  let dataArray = [];
  let property = {};

  if (data && size(data)) {
    if (!isArray(data)) {
      dataArray = [data];
    } else {
      dataArray = [...data];
    }

    dataArray.forEach((itm) => {
      property['columns'] = itm['columns'];
      property['records'] = {
        from: itm['from'],
        to: itm['to'],
        total: itm['total'],
        allCount: itm['allCount'],
      };
      property['pagination'] = {
        current_page: itm['current_page'],
        first_page_url: itm['first_page_url'],
        last_page_url: itm['last_page_url'],
        links: itm['links'],
        next_page_url: itm['next_page_url'],
        prev_page_url: itm['next_page_url'],
      };
      property['dataSize'] =
        itm['dataSize']?.length &&
        itm['dataSize'].map((el) => {
          if (el > 0) {
            return { name: el, value: el };
          } else {
            return { name: 'Όλα', value: el };
          }
        });

      if (tableType === 'offerReporting' || tableType === 'downloadLogs') {
        if (tableType === 'downloadLogs') {
          const findIndex = property['columns'].findIndex(
            (item) => item.name === 'viewLink'
          );
          if (findIndex !== -1) {
            property['columns'] = changeItemIndex(
              property['columns'],
              findIndex,
              2
            );
          }
        }
        property['data'] = offerReporting(itm['data']);
      } else if (tableType === 'bookingReporting') {
        property['data'] = bookingReporting(itm['data'], property['columns']);
      } else if (tableType === 'users') {
        const findIndex = property['columns'].findIndex(
          (item) => item.name === 'loginLink'
        );
        if (findIndex !== -1) {
          property['columns'][findIndex].label = 'Ενέργειες';
          property['columns'][findIndex].name = 'actions';
          property['columns'] = changeItemIndex(
            property['columns'],
            findIndex,
            2
          );
        }
        property['data'] = usersMap(itm['data']);
      } else if (tableType === 'companygroups') {
        property['data'] = groupsMap(itm['data']);
      }
    });
  }

  return property;
};

const offerReporting = (data) => {
  const newArray = data.map((item) => {
    const citm = { ...item };

    citm.updated_at = citm.updated_at ?? '-';
    citm.created_at = citm.created_at
      ? format(parseISO(citm.created_at), 'yyyy-MM-dd HH:mm:ss', {
          locale: locale['el'],
        })
      : '-';

    return citm;
  });

  return newArray;
};

const bookingReporting = (data, columns) => {
  const newArray = data.map((item) => {
    const citm = { ...item };

    citm.bookingType = citm.bookingType || '-';
    citm.active = citm.active === 1 ? 'Ναι' : 'Οχι';
    columns.forEach((column) => {
      let itmComponent =
        citm[column.name]?.component || citm[column.name] || '';
      if (column.type === 'date') {
        itmComponent = itmComponent
          ? format(parseISO(itmComponent), 'dd MMMM yyyy hh:mm a', {
              locale: locale['el'],
            })
          : '-';
        citm[column.name] = itmComponent;
      } else if (column.type === 'shortDate') {
        itmComponent = itmComponent
          ? format(parseISO(itmComponent), 'dd/MM/yyyy', {
              locale: locale['el'],
            })
          : '-';
        citm[column.name] = itmComponent;
      }
    });

    return citm;
  });
  return newArray;
};

const usersMap = (data) => {
  const newArray = data.map((item) => {
    const citm = { ...item };
    // check for null value and code breaks
    citm.activated_at = citm.activated_at
      ? format(parseISO(citm.activated_at), 'dd MMMM yyyy', {
          locale: locale['el'],
        })
      : '-';
    citm.created_at = citm.created_at
      ? format(parseISO(citm.created_at), 'dd MMMM yyyy', {
          locale: locale['el'],
        })
      : '-';
    citm.active = citm.active === 1 ? 'Ναι' : 'Οχι';
    return citm;
  });

  return newArray;
};

const groupsMap = (data) => {
  const newArray = data.map((item) => {
    const citm = { ...item };
    // check for null value and code breaks
    citm.updated_at = citm.updated_at
      ? format(parseISO(citm.updated_at), 'dd MMMM yyyy', {
          locale: locale['el'],
        })
      : '-';
    citm.created_at = citm.created_at
      ? format(parseISO(citm.created_at), 'dd MMMM yyyy', {
          locale: locale['el'],
        })
      : '-';
    return citm;
  });

  return newArray;
}